import { render } from "./CreateEditLicenseForm.vue?vue&type=template&id=4d42b79a&ts=true"
import script from "./CreateEditLicenseForm.vue?vue&type=script&lang=ts"
export * from "./CreateEditLicenseForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__